import styled from "styled-components";

export const Card = styled.div`
    width: 100%;
    max-width: 380px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 20px;
    background: #ffffff;
    border: 2px solid #d6d6d6;
    border-radius: 16px;
    box-sizing: border-box;
    overflow: hidden;
    justify-self: stretch;
    align-self: stretch;
`;

export const IconContainer = styled.div`
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #f3f4f6;
    color: #99a1af;
    font-size: 22px;
    font-weight: 400;
    transition: background-color 0.2s ease;
`;

export const PlusIcon = styled.img`
    width: 16px;
    height: 16px;
    transition: filter 0.2s ease;
`;

export const Title = styled.div`
    color: #99a1af;
    font-family: Roboto, sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    transition: color 0.2s ease;
`;

export const AddGatewayButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 8px 12px;
    border: 1px solid transparent;
    border-radius: 6px;
    background: transparent;
    color: inherit;
    font: inherit;
    cursor: pointer;
    transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;

    &:hover {
        background-color: #f3edff;
        border-color: #700ac1;

        ${IconContainer} {
            background-color: #700ac1;
        }

        ${PlusIcon} {
            filter: brightness(0) invert(1);
        }

        ${Title} {
            color: #700ac1;
        }
    }

    &:focus {
        outline: none;
    }

    &:focus-visible {
        outline: 2px solid #700ac1;
        outline-offset: 2px;
    }
`;

export const Description = styled.p`
    max-width: 327px;
    margin: 0;
    color: #99a1af;
    font-family: Roboto, sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    text-align: center;
`;

export const LearnMore = styled.a`
    background: none;
    border: none;
    padding: 0;
    color: #700ac1;
    font-family: Roboto, sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    cursor: pointer;
    text-decoration: none;

    &:link,
    &:visited,
    &:active {
        color: #700ac1;
    }

    &:hover {
        color: #700ac1;
        text-decoration: underline;
    }
`;
